
export const _ = {
    isObject(value) {
        return Object.prototype.toString.call(value) === '[object Object]';
    },
    isArray(value) {
        return Object.prototype.toString.call(value) === '[object Array]';
    },
    isFunction(value) {
        return Object.prototype.toString.call(value) === '[object Function]';
    },
    isDom(dom) {
        if (typeof HTMLElement === 'object') {

            return dom instanceof HTMLElement;
        } else {
            return dom && typeof dom === 'object' && dom.nodeType === 1 && typeof dom.nodeName === 'string';
        }
    }

};
export function assignDeep() {
    // eslint-disable-next-line prefer-rest-params
    const args = Array.from(arguments);
    let result = args[0];
    if (args.length < 2) {
        return result;
    }
    args.shift();
    args.forEach((item) => {
        if (_.isObject(item)) {
            if (!_.isObject(result)) {
                result = {};
            }
            for (const key in item) {
                if (_.isObject(item[key])) {
                    result[key] = result[key] || {};
                    result[key] = assignDeep(result[key], item[key]);
                } else {
                    result[key] = item[key];
                }
            }
        } else if (_.isArray(item)) {
            if (!_.isArray(result)) {
                result = [];
            }
            item.forEach((arrItem, arrIndex) => {
                if (_.isObject(arrItem)) {
                    result[arrIndex] = result[arrIndex] || {};
                    result[arrIndex] = assignDeep(result[arrIndex], arrItem);
                } else {
                    result[arrIndex] = arrIndex;
                }
            });
        }
    });
    return result;

}
